import CardCoach from './CardCoach';

export default CardCoach;
